/* Yoni Peach Care cart drawer: subscribe toggle, upsell add, carousel. Uses Shopify's Ajax Cart API only. */
(function () {
  if (window.__ypcCart) return;
  window.__ypcCart = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function drawer() { return document.querySelector('cart-drawer'); }

  function request(path, body) {
    var d = drawer();
    if (d) d.classList.add('is-busy');
    body.sections = SECTIONS;
    body.sections_url = window.location.pathname;
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (state) {
        var d = drawer();
        if (d && state.sections && typeof d.renderContents === 'function') {
          d.renderContents(state);
        } else {
          window.location.reload();
        }
        document.dispatchEvent(new CustomEvent('ypc:cart:updated', { detail: state }));
        return state;
      })
      .catch(function (err) {
        var box = document.getElementById('CartDrawer-CartErrors');
        if (box) box.textContent = (err && (err.description || err.message)) || (window.cartStrings && cartStrings.error) || 'Something went wrong. Please try again.';
      })
      .finally(function () { var d = drawer(); if (d) d.classList.remove('is-busy'); });
  }

  function setPlan(sub) {
    var toggle = sub.querySelector('.ypc-sub__toggle');
    var select = sub.querySelector('.ypc-sub__select');
    var plan = toggle.checked && select ? Number(select.value) : null;
    sub.classList.toggle('is-on', toggle.checked);
    return request('cart/change.js', {
      line: Number(sub.dataset.line),
      quantity: Number(sub.dataset.qty),
      selling_plan: plan
    });
  }

  // capture phase so Dawn's quantity "change" listener never sees these controls
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var sub = t.closest('.ypc-sub');
    if (!sub) return;
    e.stopPropagation();
    if (t.classList.contains('ypc-sub__toggle')) setPlan(sub);
    else if (t.classList.contains('ypc-sub__select') && sub.querySelector('.ypc-sub__toggle').checked) setPlan(sub);
  }, true);

  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('.ypc-upsell__add');
    if (add) {
      e.preventDefault();
      add.setAttribute('aria-busy', 'true');
      request('cart/add.js', { items: [{ id: Number(add.dataset.variantId), quantity: 1 }] });
      return;
    }
    var arrow = e.target.closest && e.target.closest('.ypc-upsell__arrow');
    if (arrow) {
      var track = arrow.closest('.ypc-upsell').querySelector('.ypc-upsell__track');
      track.scrollBy({ left: Number(arrow.dataset.dir) * track.clientWidth, behavior: 'smooth' });
    }
  });
})();
